// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".privacy .el-table td,.privacy .el-table th{padding:4px 0}", ""]);
// Exports
module.exports = exports;
